import { initSentry, SentryErrorBoundary } from '@/lib/sentry'
import { captureError } from '@/lib/analytics'
initSentry()

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

const fallback = ({ error }: { error: unknown }) => (
  <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-8 bg-[#e2e8f0] dark:bg-[#0f172a]">
    <p className="text-4xl">⚠️</p>
    <p className="text-lg font-bold text-[#0f172a] dark:text-white">Something went wrong</p>
    <p className="text-sm text-[#64748b] text-center max-w-xs">
      {(error as Error)?.message ?? 'An unexpected error occurred.'}
    </p>
    <button
      onClick={() => window.location.reload()}
      className="mt-2 px-5 py-2.5 rounded-xl bg-[#2563eb] text-white text-sm font-semibold"
    >
      Reload app
    </button>
  </div>
)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SentryErrorBoundary fallback={fallback} onError={(error) => captureError(error)}>
      <App />
    </SentryErrorBoundary>
  </StrictMode>,
)
